/**
 * Applies domain-driven branding
 */

import 'gw-portals-branding-js/SetBranding';

export default angular.module('gw-portals-branding-angular', []);